import { render, staticRenderFns } from "./BuildingConfig.vue?vue&type=template&id=5f6eaa1c"
import script from "./BuildingConfig.vue?vue&type=script&lang=js"
export * from "./BuildingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports